import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LifeChangeComponent } from './lifeChange.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { ButtonModule } from '@app/components/button/button.module';
import { MatSliderModule } from '@angular/material/slider';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';
import { PlSliderModule } from '@app/components/pl-slider/pl-slider.module';

@NgModule({
  imports: [
    CommonModule,
    PlIconModule,
    ButtonModule,
    MatSliderModule,
    FormsModule,
    TranslateModule,
    PlInputModule,
    PlSliderModule,
  ],
  declarations: [LifeChangeComponent],
  exports: [LifeChangeComponent],
})
export class LifeChangeModule {}
